// SUBMIT
export const SUBMIT_FEEDBACK = "app/FEEDBACK/SUBMIT_FEEDBACK";
export const SUBMIT_FEEDBACK_SUCCESS = "app/FEEDBACK/SUBMIT_FEEDBACK_SUCCESS";
export const SUBMIT_FEEDBACK_FAILURE = "app/FEEDBACK/SUBMIT_FEEDBACK_FAILURE";

// LIST
export const FETCH_FEEDBACK_LIST = "app/FEEDBACK/FETCH_FEEDBACK_LIST";
export const FETCH_FEEDBACK_LIST_SUCCESS =
  "app/FEEDBACK/FETCH_FEEDBACK_LIST_SUCCESS";
export const FETCH_FEEDBACK_LIST_FAILURE =
  "app/FEEDBACK/FETCH_FEEDBACK_LIST_FAILURE";

// UPDATE (submitter self-edit, only while status === 'new')
export const UPDATE_FEEDBACK = "app/FEEDBACK/UPDATE_FEEDBACK";
export const UPDATE_FEEDBACK_SUCCESS = "app/FEEDBACK/UPDATE_FEEDBACK_SUCCESS";
export const UPDATE_FEEDBACK_FAILURE = "app/FEEDBACK/UPDATE_FEEDBACK_FAILURE";

// UPDATE STATUS (product-team triage)
export const UPDATE_FEEDBACK_STATUS = "app/FEEDBACK/UPDATE_FEEDBACK_STATUS";
export const UPDATE_FEEDBACK_STATUS_SUCCESS =
  "app/FEEDBACK/UPDATE_FEEDBACK_STATUS_SUCCESS";
export const UPDATE_FEEDBACK_STATUS_FAILURE =
  "app/FEEDBACK/UPDATE_FEEDBACK_STATUS_FAILURE";
